import { BaseNavigationItemBuilder } from '@/agent/entities/navigation/BaseNavigationItemBuilder'
import { type NavAction, type NavItem, type NavItemContext, NavItemTypeEnum } from '@/common/types/navigation'
import { EvalStartNavigationItemBuilder } from '@/agent/entities/navigation/EvalStartNavigationItemBuilder'
import { EvalViewNavigationItemBuilder } from '@/agent/entities/navigation/EvalViewNavigationItemBuilder'
import { SmsNavigationItemBuilder } from '@/agent/entities/navigation/SmsNavigationItemBuilder'
import i18n from '@/plugins/i18n'
import { CaseActionModalEnum } from '@/common/types/caseAction'

const { t } = i18n.global
export class CaseActionNavigationItemBuilder extends BaseNavigationItemBuilder {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  *buildNavigationItem(action: NavAction<any>, itemContext: NavItemContext): IterableIterator<NavItem> {
    const ticketId = this.context.id

    if (action?.actionData?.action) {
      switch (action.actionData.action) {
        case 'EVAL-VIEW':
          yield* new EvalViewNavigationItemBuilder(this.context, action)
          break
        case 'EVAL-START':
          yield* new EvalStartNavigationItemBuilder(this.context, action)
          break
        case 'CONVERT_TO_SMS':
          yield* new SmsNavigationItemBuilder(this.context, action)
          break
        case 'CONVERT_TO_WHATSAPP':
          yield {
            ...this.getDefaultNavigationItem(action, itemContext),
            target: `/assist/whatsapp/create/${action.actionData.skillGroupId}?ticketId=${ticketId}`,
          }
          break
        case 'TAKEON': {
          yield {
            ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.ActionModal),
            target: CaseActionModalEnum.TAKEON,
          }
          break
        }
        case 'COMPLETE':
          yield { ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.ActionModal), target: CaseActionModalEnum.COMPLETE }
          break
        case 'REOPEN':
          yield { ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.ActionModal), target: CaseActionModalEnum.REOPEN }
          break
        case 'ASKFORVALIDATION':
          yield { ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.ActionModal), target: CaseActionModalEnum.ASKFORVALIDATION }
          break
        case 'UNDOVALIDATION':
          yield { ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.ActionModal), target: CaseActionModalEnum.UNDOVALIDATION }
          break
        case 'APPROVE':
          yield { ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.ActionModal), target: CaseActionModalEnum.APPROVE }
          break
        case 'DISAPPROVE':
          yield { ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.ActionModal), target: CaseActionModalEnum.DISAPPROVE }
          break
        case 'PUTBACKINPOOL':
          yield { ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.ActionModal), target: CaseActionModalEnum.RELEASE }
          break
        case 'ASSIGN':
          yield { ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.ActionModal), target: CaseActionModalEnum.ASSIGN }
          break
        case 'REASSIGN':
          yield { ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.ActionModal), target: CaseActionModalEnum.REASSIGN }
          break
        case 'TRANSFER':
          yield { ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.ActionModal), target: CaseActionModalEnum.TRANSFER }
          break
        case 'COMPLETEONVALIDATION':
          yield {
            ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.ActionModal),
            target: CaseActionModalEnum.COMPLETEONVALIDATION,
          }
          break
        case 'DELETE':
          yield { ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.ActionModal), target: CaseActionModalEnum.CANCEL }
          break
        case 'VIEW_CANNED_RESPONSES': {
          const navItem = this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.Event)
          navItem.payload.overrideProcessing = true
          yield {
            ...navItem,
            target: 'global:case-open-modal',
          }
          break
        }
        case 'STACK': {
          yield { ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.ActionModal), target: CaseActionModalEnum.STACK }
          break
        }
        case 'STACKANDPUTBACKINPOOL': {
          yield {
            ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.ActionModal),
            target: CaseActionModalEnum.STACKANDPUTBACKINPOOL,
          }
          break
        }
        case 'STACKANDREASSIGN': {
          yield {
            ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.ActionModal),
            target: CaseActionModalEnum.STACKANDREASSIGN,
          }
          break
        }
        case 'STACKANDTRANSFER': {
          yield {
            ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.ActionModal),
            target: CaseActionModalEnum.STACKANDTRANSFER,
          }
          break
        }
        case 'UPDATEDUEDATE': {
          yield {
            ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.ActionModal),
            target: CaseActionModalEnum.UPDATEDUEDATE,
          }
          break
        }
        default:
          yield { ...this.getDefaultNavigationItem(action, itemContext, NavItemTypeEnum.EventModal), target: 'global:case-open-modal' }
          break
      }
    } else {
      console.log(`Case Navigation Action doesn't not have any targeted action`, action)
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getDefaultNavigationItem(action: NavAction<any>, itemContext: NavItemContext, type: NavItemTypeEnum = NavItemTypeEnum.Link): NavItem {
    const navItem = super.getDefaultNavigationItem(action, itemContext, type)
    navItem.category = action.actionData.action
    navItem.payload = {
      ...navItem.payload,
      ...this.context.getToken(),
      title: action.key ? t(action.key + '.title') : navItem.text,
    }

    return navItem
  }
}
